export const groupByDate = (items: any[]) => {
  return items.reduce((groups: { [key: string]: any[] }, item: any) => {
    const date = new Date(item.created).toLocaleDateString();
    if (!groups[date]) {
      groups[date] = [];
    }
    groups[date].push(item);
    return groups;
  }, {});
};